import React, { Component } from 'react';
import { Row, Col, Input, Form, FormGroup, Table } from 'reactstrap';
import 'bootstrap/dist/css/bootstrap.css';

class MorningBandwidth extends Component {
    constructor(props) {
        super(props);
        this.selectorArr = this.props.selector != null && this.props.selector !== '' ? this.props.selector.split('/') : [];
        this.state = {
            data: [],
            sheetData: [],
            selectedEmployee: this.selectorArr.length > 0 && this.selectorArr[0] != null ? parseInt(this.selectorArr[0]) : 0,
            selectedTeam: this.selectorArr.length > 1 && this.selectorArr[1] != null ? parseInt(this.selectorArr[1]) : 0,
            selectedDepartment: this.selectorArr.length > 2 && this.selectorArr[2] != null ? parseInt(this.selectorArr[2]) : 0,
        };
        this.columns = ['Employee', 'Departments', 'Team', 'Start Date', 'Position', 'Role', 'Start Time', 'Capacity', 'Assigned', 'Availability']
    }

    componentDidMount() {
        this.props.log('MorningBandwidth.js/componentDidMount');
        this.onSubmit();
    }

    onSubmit = () => {
        this.props.log('MorningBandwidth.js/onSubmit');
        fetch('/api/reports/MorningBandwidth2', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken
            },
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    let data = results.data.map(d => {
                        return {
                            ...d,
                            clients: JSON.stringify(d.clients) !== '[{}]' ? 
                                d.clients.filter(client => client.workflows != null).map(client => {
                                    return {
                                        ...client
                                        ,workflows: client.workflows.filter(workflow => workflow.workflowId != null).map(workflow => {
                                            return {
                                                ...workflow,
                                                workflowEstimates: JSON.stringify(workflow.workflowEstimates) !== '[{}]' ? workflow.workflowEstimates : null,
                                                workflowTaskEstimates: JSON.stringify(workflow.workflowTaskEstimates) !== '[{}]' ? workflow.workflowTaskEstimates : null
                                            }
                                        })
                                    }
                                })
                            : null,
                            departments: JSON.stringify(d.departments) !== '[{}]' ? d.departments : null,
                        }
                    });
                    this.setState({
                        data: this.processData(data),
                    }, () => this.getCSVdata());
                } else {
                    this.props.addToast('Unable to download report.', 5, 'danger');
                }
            })
            // .catch(() => {
            //     this.props.addToast('An error has occurred.', 5, 'danger');
            // })
    }

    processData = (data) => {
        this.props.log('MorningBandwidth.js/processData (data)', data);
        data = data.map(item => {
            let employeeWorkflowEstimateTotal = 0;
            let employeeWorkflowTaskEstimateTotal = 0;
            if (item.clients != null) {
                item.clients.forEach(client => {
                    if (client.workflows != null) {
                        let clientWorkflowEstimateTotal = 0;
                        let clientWorkflowTaskEstimateTotal = 0;
                        client.workflows.forEach(wft => {
                            if (wft.workflowEstimates != null) {
                                wft.workflowEstimates.forEach(workflowEstimate => {
                                    if (workflowEstimate.duration != null) {
                                        clientWorkflowEstimateTotal += workflowEstimate.duration;
                                    }
                                })
                            }
                            if (wft.workflowTaskEstimates != null && clientWorkflowEstimateTotal === 0) {
                                wft.workflowTaskEstimates.forEach(workflowTaskEstimate => {
                                    if (workflowTaskEstimate.duration != null) {
                                        clientWorkflowTaskEstimateTotal += workflowTaskEstimate.duration;
                                    }
                                })
                            }
                        })
                        employeeWorkflowEstimateTotal += clientWorkflowEstimateTotal;
                        employeeWorkflowTaskEstimateTotal += clientWorkflowTaskEstimateTotal;
                    }
                })
            }
            return {
                ...item,
                startDate: this.formatDate(item.startDate),
                startTime: this.getTime(item.startTime),
                assigned: employeeWorkflowEstimateTotal + employeeWorkflowTaskEstimateTotal,
                availability: parseFloat(item.capacity) - (employeeWorkflowEstimateTotal + employeeWorkflowTaskEstimateTotal)
            }
        })
        return data;
    }

    formatDate = (d) => {
        if (parseInt(String(d).substring(0, 4)) <= 2000) return "";
        return parseInt(String(d).substring(5, 7)) + '/' + parseInt(String(d).substring(8, 10)) + '/' + parseInt(String(d).substring(0, 4));
    }

    getTime = (time) => {
        if (time == null || time === '') return '';
        var hours = parseInt(time.substring(0, 2)),
            minutes = parseInt(time.substring(3, 5)),
            ampm = 'am';
        if (hours === 12) {
            ampm = 'pm';
        } else if (hours === 0) {
            hours = 12;
        } else if (hours > 12) {
            hours -= 12;
            ampm = 'pm';
        }
        return hours + ':' + String(minutes).padStart(2, '0') + ' ' + ampm;
    }

    onChange = (e) => {
        this.props.log('MorningBandwidth.js/onChange (name, value, e)', e.target.name, e.target.value, e);
        e.persist();
        this.setState({
            [e.target.name]: parseInt(e.target.value)
        }, () => {
            this.props.changeSelector({
                target: {
                    value: String((this.state.selectedEmployee) + '/' + (this.state.selectedTeam) + '/' + (this.state.selectedDepartment)).replace('0/0/0', '')
                }
            });
            this.getCSVdata();
        }
        );
    }

    formatNegPos = (num) => {
        if (num > 0) return num + ' h';
        return '(' + num + ' h)'
    }

    getCSVdata = () => {
        this.props.log('MorningBandwidth.js/getCSVdata');
        const filteredArray = this.state.data
            .filter(employee => parseInt(this.state.selectedEmployee) === 0 || parseInt(this.state.selectedEmployee) === parseInt(employee.employeeId))
            .filter(employee => parseInt(this.state.selectedTeam) === 0 || parseInt(this.state.selectedTeam) === parseInt(employee.teamId))
            .filter(employee => parseInt(this.state.selectedDepartment) === 0 || (employee.departments != null && employee.departments.length > 0 && employee.departments.findIndex(department => department.id === this.state.selectedDepartment)) > -1);
        const totalAvailability = filteredArray.reduce((prev, cur) => prev + (!isNaN(cur.availability) ? cur.availability : 0), 0);
        let retArr = [[
            'Employee: ',
            'Team: ',
            'Department: '
        ],
        [
            document.getElementById('selectedEmployee').options[document.getElementById('selectedEmployee').selectedIndex].text,
            document.getElementById('selectedTeam').options[document.getElementById('selectedTeam').selectedIndex].text,
            document.getElementById('selectedDepartment').options[document.getElementById('selectedDepartment').selectedIndex].text
        ],
        [], this.columns];
        retArr = retArr.concat(this.state.data
            .filter(employee => parseInt(this.state.selectedEmployee) === 0 || this.state.selectedEmployee === employee.employeeId)
            .filter(employee => parseInt(this.state.selectedTeam) === 0 || this.state.selectedTeam === employee.teamId)
            .filter(employee => parseInt(this.state.selectedDepartment) === 0 || (employee.departments != null && employee.departments.findIndex(department => department.id === this.state.selectedDepartment)) > -1)
            .map(employee => ([
                employee.lastName + ', ' + employee.firstName,
                employee.departments != null && employee.departments.length > 0 ? [...employee.departments].map(department => department.departmentName).join(', ') : '',
                employee.team,
                employee.startDate,
                employee.jobTitle,
                employee.role1,
                employee.startTime,
                employee.capacity > 0 ? employee.capacity : '',
                employee.assigned > 0 ? employee.assigned : '',
                employee.availability !== 0 && !isNaN(employee.availability) ? employee.availability : ''
            ]
            )))
        retArr.push([
            'Totals', '', '', '', '', '', '',
            filteredArray.reduce((prev, cur) => prev + cur.capacity, 0),
            filteredArray.reduce((prev, cur) => prev + cur.assigned, 0),
            totalAvailability !== 0 && !isNaN(totalAvailability) ? totalAvailability : '--'
        ])
        this.props.passData(retArr, "morning-bandwidth");
    }

    render() {
        this.props.info('MorningBandwidth.js/render');
        const filteredArray = this.state.data
            .filter(employee => parseInt(this.state.selectedEmployee) === 0 || parseInt(this.state.selectedEmployee) === parseInt(employee.employeeId))
            .filter(employee => parseInt(this.state.selectedTeam) === 0 || parseInt(this.state.selectedTeam) === parseInt(employee.teamId))
            .filter(employee => parseInt(this.state.selectedDepartment) === 0 || (employee.departments != null && employee.departments.length > 0 && employee.departments.findIndex(department => department.id === this.state.selectedDepartment)) > -1);
        const totalAvailability = filteredArray.reduce((prev, cur) => prev + (!isNaN(cur.availability) ? cur.availability : 0), 0);
        return (
            <>
                <Row className="mt-4">
                    <Col>
                        <Form inline>
                            <FormGroup className='mr-2'>
                                <Input type="select"
                                    name="selectedEmployee"
                                    id="selectedEmployee"
                                    onChange={(e) => this.onChange(e)}
                                    value={this.props.isFieldNull(this.state.selectedEmployee)}
                                >
                                    <option value="0">ALL EMPLOYEES</option>
                                    {
                                        this.state.data.map(employee => (
                                            <option
                                                key={"employee_" + employee.employeeId}
                                                value={this.props.isFieldNull(employee.employeeId)}
                                            >{employee.lastName + ', ' + employee.firstName}</option>
                                        ))
                                    }
                                </Input>
                            </FormGroup>
                            <FormGroup className='mr-2'>
                                <Input type="select"
                                    name="selectedTeam"
                                    id="selectedTeam"
                                    onChange={(e) => this.onChange(e)}
                                    value={this.props.isFieldNull(this.state.selectedTeam)}
                                >
                                    <option value="0">ALL TEAMS</option>
                                    {
                                        [...new Set(
                                            [...this.state.data]
                                                .map(employee => { return JSON.stringify({ team: employee.team, teamId: employee.teamId }) })
                                        )].map(team => JSON.parse(team))
                                            .sort((a, b) => a.team.localeCompare(b.team))
                                            .map(team => (
                                                <option
                                                    key={"team_" + team.teamId}
                                                    value={this.props.isFieldNull(team.teamId)}
                                                >{team.team}</option>
                                            ))
                                    }
                                </Input>
                            </FormGroup>
                            <FormGroup className='mr-2'>
                                <Input type="select"
                                    name="selectedDepartment"
                                    id="selectedDepartment"
                                    onChange={(e) => this.onChange(e)}
                                    value={this.props.isFieldNull(this.state.selectedDepartment)}
                                >
                                    <option value="0">ALL DEPARTMENTS</option>
                                    {
                                        [...new Set(
                                            [...this.state.data]
                                                .filter(employee => employee.departments != null)
                                                .map(employee => employee.departments).flat()
                                                .map(departments => { return JSON.stringify({ id: departments.id, departmentName: departments.departmentName }) })
                                        )]
                                            .map(department => JSON.parse(department))
                                            .sort((a, b) => a.departmentName.localeCompare(b.departmentName))
                                            .map(department => (
                                                <option
                                                    key={"department_" + department.id}
                                                    value={this.props.isFieldNull(department.id)}
                                                >{department.departmentName}</option>
                                            ))
                                    }
                                </Input>
                            </FormGroup>
                        </Form>
                    </Col>
                </Row>
                <Table className='mt-3'>
                    <thead>
                        <tr>
                            {this.columns.map(col => (
                                <th key={col}>{col}</th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {filteredArray.map(employee => (
                            <tr key={employee.employeeId}>
                                <td>{employee.lastName}, {employee.firstName}</td>
                                <td>{employee.departments != null && employee.departments.length > 0 ? [...employee.departments].map(department => department.departmentName).join(', ') : ''}</td>
                                <td>{employee.team}</td>
                                <td>{employee.startDate}</td>
                                <td>{employee.jobTitle}</td>
                                <td>{employee.role1}</td>
                                <td>{employee.startTime}</td>
                                <td>{employee.capacity > 0 ? employee.capacity + ' h' : '--'}</td>
                                <td>{employee.assigned > 0 ? employee.assigned + ' h' : '--'}</td>
                                <td>{employee.availability !== 0 && !isNaN(employee.availability) ? this.formatNegPos(employee.availability) : '--'}</td>
                            </tr>
                        ))
                        }
                    </tbody>
                    <tfoot>
                        <tr className='font-weight-bold'>
                            <td>Totals</td>
                            <td colSpan={6}></td>
                            <td>{/*filteredArray.reduce((prev, cur) => prev + cur.capacity, 0)*/} --</td>
                            <td>{Number(filteredArray.reduce((prev, cur) => prev + cur.assigned, 0)).toFixed(2)} h</td>
                            <td>{totalAvailability !== 0 && !isNaN(totalAvailability) ? this.formatNegPos(totalAvailability) : '--'}</td>
                        </tr>
                    </tfoot>
                </Table>
            </>
        );

    }
}

export default MorningBandwidth;
